// import axios from "axios";
import ls from "local-storage";
import { SET_ACCOUNT_INFO, REMOVE_ACCOUNT_INFO } from "@/store/mutation-types";

const getAccountInfo = ({ commit }) => {
  commit(SET_ACCOUNT_INFO, ls.get('user'));
};

const removeAccountInfo = ({ commit }) => {
  commit(REMOVE_ACCOUNT_INFO);
};

export default {
  getAccountInfo,
  removeAccountInfo,
};
